import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage'
import HotNews from '../views/HotNews'
import User from '../views/User'
import MyProduct from '../views/User/myProduct'
import ProductList from '../views/Product'
import WorkList from '../views/Work'
import WorkDetail from '../views/Work/workDetail.vue'
import CommonProductDetail from '../views/Product/productDetail.vue'
import MyService from '../views/User/myService'
import MyCollection from '../views/User/myCollection'
import ProductAdd from '../views/User/productAdd.vue'
import ProductDetail from '../views/User/productDetail.vue'
import PolicyInquiriesRole from '../views/PolicyInquiriesRole'
import PolicyInquiries from '../views/PolicyInquiries'
import ServiceMarket from '../views/ServiceMarket'
import Service from '../views/Service'
import ServiceAdd from '../views/Service/add.vue'
import NewsDetail from '../views/NewsDetail'
import PolicyDetail from '../views/PolicyDetail'
import TalentActivities from '../views/TalentActivities'
import ActivityDetail from '../views/ActivityDetail'
import ServiceMarketDetail from '../views/ServiceMarketDetail'

Vue.use(VueRouter)

//添加以下代码
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err) => err)
// }
const routes = [
  {
    path: '/',
    name: '首页',
    meta: { title: '首页' },
    component: HomePage,
  },
  {
    path: '/hot-news',
    name: '热点资讯',
    meta: { title: '首页' },
    component: HotNews,
  },
  {
    path: '/policy-inquiries',
    name: '政策查询',
    meta: { title: '政策查询' },
    component: PolicyInquiries,
  },
  {
    path: '/policy-inquiries/:role',
    name: '政策查询详情',
    meta: { title: '政策查询' },
    component: PolicyInquiriesRole,
  },
  {
    path: '/service-market',
    name: '服务超市',
    meta: { title: '服务超市' },
    component: ServiceMarket,
  },
  {
    path: '/service-marketdetail',
    name: '服务超市简介详情',
    meta: { title: '服务超市' },
    component: ServiceMarketDetail,
  },
  {
    path: '/talent-activities',
    name: '人才活动',
    meta: { title: '人才活动' },
    component: TalentActivities,
  },
  {
    path: '/service',
    name: '服务诉求',
    meta: { title: '服务诉求' },
    component: Service,
  },
  {
    path: '/service/add',
    name: '服务诉求',
    meta: { title: '服务诉求' },
    component: ServiceAdd,
  },
  {
    path: '/activity-Detail/:id',
    name: '活动详情',
    meta: { title: '人才活动' },
    component: ActivityDetail,
  },
  {
    path: '/news-detail/:id',
    name: '资讯详情',
    meta: { title: '首页' },
    component: NewsDetail,
  },
  {
    path: '/policy-detail/:id',
    name: '政策详情',
    meta: { title: '政策查询' },
    component: PolicyDetail,
  },
  {
    path: '/user',
    name: '个人中心',
    meta: { title: '个人中心' },
    component: User,
    children: [
      {
        path: 'myProduct',
        component: MyProduct,
        name: '我的产品',
      },
      {
        path: 'myService',
        component: MyService,
        name: '我的诉求',
      },
      {
        path: 'myCollection',
        component: MyCollection,
        name: '我的收藏',
      },
    ],
  },
  {
    path: '/user/product/add',
    name: '发布产品',
    meta: { title: '发布产品' },
    component: ProductAdd,
  },
  {
    path: '/user/product/detail',
    name: '产品详情',
    meta: { title: '产品详情' },
    component: ProductDetail,
  },
  {
    path: '/product/detail',
    name: '产品详情',
    meta: { title: '产品详情' },
    component: CommonProductDetail,
  },
  {
    path: '/product/list',
    name: '产品列表',
    meta: { title: '产品列表' },
    component: ProductList,
  },
  {
    path: '/work/list',
    name: '成果展列表',
    meta: { title: '成果展列表' },
    component: WorkList,
  },
  {
    path: '/work/detail',
    name: '成果展列表',
    meta: { title: '成果展列表' },
    component: WorkDetail,
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
